// extracted by mini-css-extract-plugin
module.exports = {"list":"Checklist_list__1cj2m","item":"Checklist_item__2xfKD","icon":"Checklist_icon__3AH51"};